import { FC, useContext } from "react";
import { EcdGenerateReportContext } from "../contexts/EcdGenerateReportContext";
import LineOfBusinessTable from "../components/LineOfBusinessTable";


const LineOfBusinessExport: FC = () => {
  const wizardContext = useContext(EcdGenerateReportContext);
  const title = "Line of Business Overview";

  return (
    <div className="ecd-export__wrapper">
      <h2 className="qes-dashboard-tile__title ecd-export__head">{title}</h2>
      <LineOfBusinessTable tableData={wizardContext.lineOfBusinessData} />
    </div>
  );
}

export default LineOfBusinessExport;